import { chatbot } from "../Services/ChatbotService.ts";
import {
  chatbotInstructionsuccessResponse,
  chatbotInstructionfailResponse,
  chatpayload,
} from "./types/chatbot.model.ts";
import { chatbotHistorySuccessResponse } from "./types/chatbot.model.ts";

export const chatbotInstruction = async (
  chatPayload: chatpayload
): Promise<chatbotInstructionsuccessResponse | chatbotInstructionfailResponse> => {
  try {
    let response;

    response = await chatbot.chatbotInstruction(chatPayload);

    const data = response.data;
    return data;
  } catch (chatbotInstructionfailResponse) {
    throw chatbotInstructionfailResponse;
  }
};

export const chatbotHistory = async (
  dataset_id: number,
  file_id: number,
  isDataSetView: boolean = false
): Promise<chatbotHistorySuccessResponse[]> => {
  try {
    let response;
    if (isDataSetView) {
      response = await chatbot.chatbotHistory(dataset_id);
    } else {
      response = await chatbot.chatbotHistory(dataset_id, file_id);
    }

    const data = response.data;
    return data;
  } catch (error) {
    // Check if it's a 404 error and return empty array
    if (error.response && error.response.status === 404) {
      return []; // Return empty array instead of throwing error
    }

    // For other errors, you might still want to throw or handle differently
    console.error('Chatbot history error:', error);
    throw error; // or return [] for all errors if you prefer
  }
}

export const download_csv = async (chat_id: number):
  Promise<any> => {
  try {
    let response;
    response = await chatbot.downloadCSV(chat_id);
    const data = response.data;
    return data;
  } catch (downloadCSVFailResponse) {
    throw downloadCSVFailResponse;
  }
} 
